module.exports = __webpack_public_path__ + "media/divinea.1f71c294.mp4";